const onlineBookingTypes = {
  GET_ALL_ONLINE_BOOKING: 'GET_ALL_ONLINE_BOOKING',
  SET_ALL_ONLINE_BOOKING: 'SET_ALL_ONLINE_BOOKING',
  GET_ONLINE_BOOKING_DETAILS: 'GET_ONLINE_BOOKING_DETAILS',
  UPDATE_BOOKING_STATUS: 'UPDATE_BOOKING_STATUS',
  GET_HOME_COLLECTION_LOGISTICS: 'GET_HOME_COLLECTION_LOGISTIC',
  VERIFY_PAYMENT_STATUS: 'VERIFY_PAYMENT_STATUS'
};

export default onlineBookingTypes;
